module.exports = __webpack_public_path__ + "img/user.7f77ffee.png";